import styles from './styles.module.scss';

import { ControlWrapper } from '../../../../components';

import { GeneralData } from './GeneralData';

export const GeneralSection = () => {
  return (
    <ControlWrapper columns={3} className={styles.root}>
      <GeneralData />
    </ControlWrapper>
  );
};
